import { render, staticRenderFns } from "./GeneralInstitutionAttribution.vue?vue&type=template&id=51606dea"
import script from "./GeneralInstitutionAttribution.vue?vue&type=script&lang=js"
export * from "./GeneralInstitutionAttribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51606dea')) {
      api.createRecord('51606dea', component.options)
    } else {
      api.reload('51606dea', component.options)
    }
    module.hot.accept("./GeneralInstitutionAttribution.vue?vue&type=template&id=51606dea", function () {
      api.rerender('51606dea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/chart/GeneralInstitutionAttribution.vue"
export default component.exports